import React from 'react';
import AuthHeaderLayout from './AuthHeaderLayout';
import styled from 'styled-components';
import { Container } from '@mui/material';

const AuthLayout = ({ leftContent, children }) => {
  return (
    <AuthWrapper>
      <AuthHeaderLayout />
      <AuthContentWrapper className="login-container">
        <div className="col-left">{leftContent}</div>
        <div className="col-right">{children}</div>
      </AuthContentWrapper>
    </AuthWrapper>
  );
};

const AuthWrapper = styled.div`
  min-height: 100vh;
`;
const AuthContentWrapper = styled(Container)`
  min-height: calc(98vh - 90px);
  padding-bottom: 0px;
  &.login-container {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 0 22px;
    // padding: 10px 10px 20px;
    border-radius: 22px;

    .col-left {
      width: 100%;
      margin-bottom: 0px;
    }

    .col-right {
      margin: 0 0 0 auto;
    }

    &.signup-conatiner {
      background: #e9f7ff;
    }

    @media all and (max-width: 768px) {
      background: #e9f7ff;
      flex-direction: column;
      justify-content: flex-start;

      .col-left {
        width: 100%;
        margin-bottom: 20px;
        .gpk {
          display: none;
        }
      }
      .col-right {
        margin: 0;
      }
    }
    @media all and (max-width: 520px) {
      .col-left {
        margin-bottom: 10px;
      }
    }
  }
`;

export default AuthLayout;
